var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "60", height: "60", viewBox: "0 0 60 60" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", stroke: "#258518", strokeWidth: "2" },
      React.createElement("path", { d: "M8 53h44H8zM10 9h40-40z" }),
      React.createElement("path", { fill: "#FFF", d: "M11 9v44h38V9H11z" }),
      React.createElement("path", { d: "M17 14a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-4z" }),
      React.createElement("path", { d: "M17 14a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-4zM17 28a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-4z" }),
      React.createElement("path", { d: "M17 28a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-4zM17 42a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-3z" }),
      React.createElement("rect", { width: "6", height: "9", x: "27", y: "14", rx: "2" }),
      React.createElement("rect", { width: "6", height: "4", x: "27", y: "14", rx: "2" }),
      React.createElement("rect", { width: "6", height: "9", x: "27", y: "28", rx: "2" }),
      React.createElement("rect", { width: "6", height: "4", x: "27", y: "28", rx: "2" }),
      React.createElement("rect", { width: "5", height: "6", x: "27", y: "42", rx: "2" }),
      React.createElement("path", { d: "M39 14a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-4z" }),
      React.createElement("path", { d: "M39 14a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-4zM39 28a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-4z" }),
      React.createElement("path", { d: "M39 28a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-4zM38 42a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-6z" }),
      React.createElement("rect", { width: "1", height: "1", x: "42", y: "48", fill: "#390", rx: ".5" })
    )
  );
});